/**
 * 共有 URL の生成（FR-LINK-05・FR-API-02）。
 *
 * 既定では現在の location にビューワの状態を重ねた絶対 URL を返す。ハッシュの合成は
 * hash-codec に任せるので、他のビューワのキーや素のアンカーはそのまま残る。
 *
 * `canonicalBase`（M5b-2）が与えられれば、現在ページではなくサーバの正規 OGP ページ
 * （/view/{slug}）へ状態を重ねる。これにより共有 URL がクローラ/SNS でプレビューを出す。
 * 正規ページには既存ハッシュが無いので `applyHash('', …)` で状態だけを載せる。
 *
 * ハッシュナビが無効（`hash: false`）でも生成できる — ルータは「監視と書き戻し」の
 * 責務しか持たず、語彙と URL 生成はここと hash-codec にあるため。
 */
import { applyHash, type HashState } from './hash-codec';

export function buildShareUrl(
  view: Window,
  prefix: string,
  state: HashState,
  canonicalBase?: string | null,
): string {
  if (canonicalBase) {
    return `${canonicalBase}${applyHash('', prefix, state)}`;
  }
  const { origin, pathname, search, hash } = view.location;
  return `${origin}${pathname}${search}${applyHash(hash, prefix, state)}`;
}
